<hyperkit-dialog class="hyperkit-component" headerText="Delete Environment">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <hyperkit-typography variant="body" size="md" align="left" color="body">
          Are you sure you want to delete environment
          <strong>{{ environment.name }}</strong> and all associated
          tools?</hyperkit-typography
        >
        @if (error) {
          <p class="errors" [ngClass]="{ 'has-errors': !!error }">
            {{ error }}
          </p>
        }
        <hyperkit-button
          size="small"
          color="tertiary"
          text=" Yes, delete environment"
          (click)="onSubmit()"
        ></hyperkit-button>
      </div>
    </div>
  </div>
</hyperkit-dialog>
